import Typography from 'typography';
import funstonTheme from 'typography-theme-funston'
const typography = new Typography(funstonTheme)
const rhythm = typography.rhythm;

export { typography, rhythm };
